import { createFileRoute, useParams, Outlet } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"
import SideBar, {
  SideBarProps,
} from "@/pages/medewerkers/$userId/components/SideBar"
import { LayoutWithSidebar } from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"

export const Route = createFileRoute("/beheer/medewerkers/$userId")({
  component: Parent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function Parent() {
  const { userId } = useParams({
    from: "/beheer/medewerkers/$userId",
  })

  const sidebarNavigationItems: SideBarProps["sidebarNavigationItems"] = [
    {
      label: "Persoonlijke gegevens",
      to: "/beheer/medewerkers/$userId/persoonlijke_gegevens",
    },
    {
      label: "Zakelijke gegevens",
      to: "/beheer/medewerkers/$userId/zakelijke_gegevens",
      freelancerOnly: true,
    },
    {
      label: "Lesbevoegdheid",
      to: "/beheer/medewerkers/$userId/lesbevoegdheid",
      teacherOnly: true,
    },
    { label: "Dossier", to: "/beheer/medewerkers/$userId/dossier" },
    {
      label: "Beschikbaarheid",
      to: "/beheer/medewerkers/$userId/beschikbaarheid",
      teacherOnly: true,
    },
    {
      label: "Agenda",
      to: "/beheer/medewerkers/$userId/agenda",
      teacherOnly: true,
    },
    {
      label: "Leslocaties",
      to: "/beheer/medewerkers/$userId/leslocaties",
      teacherOnly: true,
    },
    {
      label: "Groepen",
      to: "/beheer/medewerkers/$userId/groepen",
      requiredPermission: { action: "read", entity: "employees" },
    },
  ]

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <SideBar
            userId={Number(userId)}
            sidebarNavigationItems={sidebarNavigationItems}
          />
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
